module.exports = __webpack_public_path__ + "images/other/search_mode_description-71ca92c6.png";